let API_URL = 'https://www.astralconsultants.com/services'

export {API_URL}